import { render } from "./SettleDatesList.vue?vue&type=template&id=6508bd39&scoped=true"
import script from "./SettleDatesList.vue?vue&type=script&lang=js"
export * from "./SettleDatesList.vue?vue&type=script&lang=js"

import "./SettleDatesList.vue?vue&type=style&index=0&id=6508bd39&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Pablo Sastre\\OneDrive\\Escritorio\\BAIPManagerTestv2\\BaipMarket.Dashboard\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6508bd39"]])

export default __exports__